import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { IconCheck } from '@calendly/ui/components/glyphs/IconCheck';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorTextDisabled, colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { INTEGRATIONS, NON_EXCLUSIVE_LOCATIONS, PHONE_CALL_KINDS } from 'components/event_type_edit/location_v3/constants';
import { getLabelForKind } from 'components/event_type_edit/location_v3/utils';
const resolvePhoneKind = possibleKinds => {
  if (possibleKinds.includes(PHONE_CALL_KINDS.outbound)) return PHONE_CALL_KINDS.outbound;
  if (possibleKinds.includes(PHONE_CALL_KINDS.inbound)) return PHONE_CALL_KINDS.inbound;
  return null;
};
const MORE_OPTIONS_ORDER = ['physical', 'phone', 'custom', 'ask_invitee'];
const DESCRIPTION_KEY_FOR_KIND = {
  custom: 'publisher.event_type_editor_crud.meeting_details.location.custom_description',
  ask_invitee: 'publisher.event_type_editor_crud.meeting_details.location.ask_invitee_description'
};
const getDescriptionForKind = kind => DESCRIPTION_KEY_FOR_KIND[kind] ? I18n.t(DESCRIPTION_KEY_FOR_KIND[kind]) : null;
const getLocationSections = possibleKinds => {
  const phoneKind = resolvePhoneKind(possibleKinds);
  const videoConferencingKinds = INTEGRATIONS.filter(kind => possibleKinds.includes(kind));
  const moreOptionKinds = MORE_OPTIONS_ORDER.map(kind => kind === 'phone' ? phoneKind : kind).filter(kind => kind && possibleKinds.includes(kind));
  return {
    videoConferencingKinds,
    moreOptionKinds
  };
};
const isKindTaken = (kind, takenKinds) => {
  if (kind === PHONE_CALL_KINDS.outbound || kind === PHONE_CALL_KINDS.inbound) {
    return takenKinds.includes(PHONE_CALL_KINDS.outbound) || takenKinds.includes(PHONE_CALL_KINDS.inbound);
  }
  return takenKinds.includes(kind) && !NON_EXCLUSIVE_LOCATIONS.includes(kind);
};
const panelCss = "p1kjfl12";
export const LocationOptionsPanel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(panelCss, props.className)} />;
});
const sectionHeaderCss = "s10gw2et";
const optionRowCss = "o1haakc2";
const optionRowAlignCenterCss = "o8i1omg";
const optionRowAlignTopCss = "ot1ki69";
const optionRowDisabledCss = "o4mt5fn";
/* stylelint-enable declaration-no-important */

const OptionRow = forwardRef((props, ref) => {
  const {
    isDisabled,
    as: AsComponent,
    ...restProps
  } = props;
  return <BareButton as={AsComponent || 'button'} ref={ref} {...restProps} className={classNames(optionRowCss, {
    [optionRowDisabledCss]: isDisabled
  }, props.className)} />;
});
const optionIconCss = "obwt92u";
const optionIconFillCss = "o11kdfih";
const optionIconLargeCss = "ouhhl6";
const optionTextCss = "o1xtthvq";
const OptionList = ({
  kinds,
  takenKinds,
  onSelect,
  iconSize
}) => <>
    {kinds.map(kind => {
    const isTaken = isKindTaken(kind, takenKinds);
    const description = getDescriptionForKind(kind);
    return <OptionRow key={kind} as={isTaken ? 'div' : 'button'} isDisabled={isTaken} disabled={isTaken} onClick={isTaken ? undefined : () => onSelect(kind)} className={description ? optionRowAlignTopCss : optionRowAlignCenterCss}>
          <span className={classNames(optionIconCss, {
        [optionIconLargeCss]: iconSize === 'large'
      })}>
            <LocationIcon useCrudIcons kind={kind} className={optionIconFillCss} />
          </span>
          <span className={optionTextCss}>
            <BodyText as="span" size="medium" color={isTaken ? colorTextDisabled : undefined}>
              {getLabelForKind(kind)}
            </BodyText>
            {description && <BodyText as="span" size="small" color="muted">
                {description}
              </BodyText>}
          </span>
          {isTaken && <UiIcon icon={IconCheck} size="small" title="" />}
        </OptionRow>;
  })}
  </>;
export const LocationOptionSections = ({
  possibleKinds,
  takenKinds = [],
  onSelect
}) => {
  const {
    videoConferencingKinds,
    moreOptionKinds
  } = getLocationSections(possibleKinds);
  return <>
      {videoConferencingKinds.length > 0 && <>
          <div className={sectionHeaderCss}>
            <TitleText as="div" size="x-small" color={colorTextSecondary}>
              {I18n.t('publisher.event_type_editor_crud.meeting_details.location.video_conferencing_label')}
            </TitleText>
          </div>
          <OptionList kinds={videoConferencingKinds} takenKinds={takenKinds} onSelect={onSelect} iconSize="large" />
        </>}
      {moreOptionKinds.length > 0 && <>
          <div className={sectionHeaderCss}>
            <TitleText as="div" size="x-small" color={colorTextSecondary}>
              {I18n.t('publisher.event_type_editor_crud.meeting_details.location.more_options_label')}
            </TitleText>
          </div>
          <OptionList kinds={moreOptionKinds} takenKinds={takenKinds} onSelect={onSelect} />
        </>}
    </>;
};

require("./location_options_panel.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_options_panel.js");